module.exports = __webpack_public_path__ + "img/1002_pc.1acdbe8b.gif";